// rc-upload 4.3.3
import Upload from './Upload';
export default Upload;
